(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["frequently-bought-together"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__fbtCartBound) return;
    window.__fbtCartBound = true;

    function buildMoneyFormatter(template) {
      var fallback = function (cents) { return '£' + (cents / 100).toFixed(2); };
      if (!template) return fallback;
      var m = template.match(/^(.*?)\{\{\s*(amount[a-z_]*)\s*\}\}(.*?)$/);
      if (!m) return fallback;
      var prefix = m[1], type = m[2], suffix = m[3];
      return function (cents) {
        var n = cents / 100;
        var value;
        switch (type) {
          case 'amount_no_decimals':
          case 'amount_no_decimals_with_comma_separator':
          case 'amount_no_decimals_with_space_separator':
            value = Math.round(n).toString();
            break;
          case 'amount_with_comma_separator':
            value = n.toFixed(2).replace('.', ',');
            break;
          case 'amount_with_space_separator':
            value = n.toFixed(2).replace('.', ' ');
            break;
          case 'amount_with_apostrophe_separator':
            value = n.toFixed(2).replace('.', "'");
            break;
          default:
            value = n.toFixed(2);
        }
        return prefix + value + suffix;
      };
    }

    function recalcTotal(root) {
      var formatter = buildMoneyFormatter(root.dataset.moneyFormat);
      var total = 0;
      var checks = root.querySelectorAll('.fbt-cart__check');
      checks.forEach(function (cb) {
        var card = cb.closest('.fbt-cart__card');
        if (cb.checked) {
          total += parseInt(cb.dataset.priceCents || '0', 10);
          if (card) card.classList.remove('is-unchecked');
        } else if (card) {
          card.classList.add('is-unchecked');
        }
      });
      var totalEl = root.querySelector('.fbt-cart__total-value');
      if (totalEl) {
        totalEl.dataset.totalCents = String(total);
        totalEl.textContent = formatter(total);
      }
      var submit = root.querySelector('.fbt-cart__submit');
      if (submit) submit.disabled = total === 0;
    }

    document.addEventListener('change', function (e) {
      var target = e.target;
      if (!target || !target.classList || !target.classList.contains('fbt-cart__check')) return;
      var root = target.closest('.fbt-cart');
      if (root) recalcTotal(root);
    });

    document.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.classList || !target.classList.contains('fbt-cart__submit')) return;
      var root = target.closest('.fbt-cart');
      if (!root) return;

      var items = [];
      root.querySelectorAll('.fbt-cart__check:checked').forEach(function (cb) {
        items.push({ id: parseInt(cb.dataset.variantId, 10), quantity: 1 });
      });
      if (!items.length) return;

      var feedback = root.querySelector('.fbt-cart__feedback');
      var addUrl = root.dataset.cartAddUrl || '/cart/add';
      var cartUrl = root.dataset.cartUrl || '/cart';

      target.disabled = true;
      target.textContent = 'Adding...';
      if (feedback) feedback.textContent = '';

      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add_failed');
          return r.json();
        })
        .then(function () { window.location.href = cartUrl; })
        .catch(function () {
          target.disabled = false;
          target.textContent = 'Add to cart';
          if (feedback) feedback.textContent = 'Could not add items. Please try again.';
        });
    });

    function loadSection(section) {
      if (section.dataset.loaded === 'true') return;
      var url = section.dataset.url;
      if (!url) return;
      section.dataset.loaded = 'true';

      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('.fbt-cart');
          if (fresh && fresh.querySelector('.fbt-cart__items')) {
            section.innerHTML = fresh.innerHTML;
            recalcTotal(section);
          }
        })
        .catch(function () {});
    }

    function init() {
      var sections = document.querySelectorAll('.fbt-cart[data-url]');
      if (!sections.length) return;
      sections.forEach(function (s) { recalcTotal(s); });
      if (!('IntersectionObserver' in window)) {
        sections.forEach(loadSection);
        return;
      }
      var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            obs.unobserve(entry.target);
            loadSection(entry.target);
          }
        });
      }, { rootMargin: '0px 0px 600px 0px' });
      sections.forEach(function (s) { observer.observe(s); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
